class TeamLineupStatsModel {
    constructor (data) {
        this.playersById = {};
        this.isDataLoaded = true;
        if (data) {
            this.parseData(data);
        }
    }

    parseData(data) {
        const that = this;
        data?.people?.forEach((player) => {
            if (player?.stats && player?.stats?.length > 0) {
                for (let i = 0; i < player.stats.length; i++) {
                    const statsSplits = player.stats[i].splits || [];

                    if (statsSplits.length > 1) {
                        statsSplits.forEach(function(statSplit) {
                            if (typeof that.playersById[player?.id] === 'undefined') {
                                that.playersById[player.id] = {};
                            }
                            if(statSplit?.numTeams > 0) {
                                that.playersById[player.id] = statSplit.stat;
                            }
                        });

                    } else if (statsSplits.length === 1) {
                        that.playersById[player.id] = statsSplits[0].stat;
                    } else {
                        that.playersById[player.id] = null;
                    }
                }

            } else {
                that.playersById[player.id] = {};
            }
        });

    }
}

export default TeamLineupStatsModel;
